import * as React from 'react';

import { PageSeoInfo } from 'components';
import { useBrandAction, useBrandValue } from 'context';

const BrandSeoInfo = () => {
  const { title, seo, ownerType } = useBrandValue();
  const action = useBrandAction();

  return (
    <PageSeoInfo
      seo={seo}
      ownerType={ownerType}
      defaultName={title}
      onUpdateSeoInfo={result => {
        action({
          type: 'UPDATE_BRAND_SEO',
          payload: {
            seo: result,
          },
        });
      }}
    />
  );
};

export { BrandSeoInfo };
